import { render, staticRenderFns } from "./Chess.vue?vue&type=template&id=4db8145c&"
import script from "./Chess.vue?vue&type=script&lang=js&"
export * from "./Chess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports